// assets
import { IconCloudUpload, IconDashboard, IconDeviceAnalytics} from '@tabler/icons';
import { IconBrandFramer, IconTypography, IconPalette, IconShadow, IconWindmill, IconLayoutGridAdd, IconArrowsLeftRight, IconUsers} from '@tabler/icons';

// constant
const icons = {
    IconDashboard: IconDashboard,
    IconCloudUpload: IconCloudUpload,
    IconDeviceAnalytics,
    IconTypography: IconTypography,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconWindmill: IconWindmill,
    IconBrandFramer: IconBrandFramer,
    IconLayoutGridAdd: IconLayoutGridAdd,
    IconArrowsLeftRight,
    IconUsers
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dữ liệu máy chấm công',
            type: 'item',
            url: '/dashboard/terminal',
            icon: icons['IconDashboard'],
            breadcrumbs: false
        },
        {
            id: 'timesheet',
            title: 'Danh sách chấm công',
            type: 'item',
            url: '/dashboard/timesheet',
            icon: icons['IconDashboard'],
            breadcrumbs: false
        },
        {
            id: 'timesheet-submit',
            title: 'Nộp chấm công',
            type: 'item',
            url: '/dashboard/timesheet-submit',
            icon: icons['IconCloudUpload'],
            breadcrumbs: false
        },
        {
            id: 'leave-submission',
            title: 'Nộp Nghỉ Việc',
            type: 'item',
            url: '/dashboard/leave-submission',
            icon: icons['IconCloudUpload'],
            breadcrumbs: false
        },
        // {
        //     id: 'call_details',
        //     title: 'Chi tiết cuộc gọi',
        //     type: 'item',
        //     url: '/dashboard/history',
        //     icon: icons['IconArrowsLeftRight'],
        //     breadcrumbs: false
        // },
        {
            id: 'users',
            title: 'Quản lý người dùng',
            type: 'item',
            url: '/dashboard/users',
            icon: icons['IconUsers'],
            breadcrumbs: false
        }
    ]
};
